import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from '@react-pdf/renderer';
import ReportTableRow from './ReportTableRow';

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
});

const ReportTableItems = ({ columns, table }) => (
  <View style={styles.tableContainer}>
    <ReportTableRow columns={columns} items={table.items} />
  </View>
);

ReportTableItems.defaultProps = {
  columns: [],
  table: {},
};

ReportTableItems.propTypes = {
  columns: PropTypes.array,
  table: PropTypes.object,
};

export default ReportTableItems;
